var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GroupedCourseCard'),_c('v-btn',{staticStyle:{"position":"fixed","bottom":"10px","right":"10px","outline":"none"},attrs:{"fab":"","dark":"","color":"purple","to":"/create_course"}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }